<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"></organization-select>        
                                            
<site-select            #siteManager
                        [org]           =   "orgManager?.currentValue"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"
                        (change)        =   "setSite($event)"></site-select>
                        <br>

<help-alert 
                        action      = "help.page.service.action" 
                        description = "help.page.service.description" 
                        info        = "help.info"></help-alert>

<br>
<br>

<custom-table           #serviceTable
                        table_id            =   "serviceManageTable"
                        no_title_value      =   "tables.service.no_title_value"
                        title_single        =   "tables.service.title_single"
                        title_multiple      =   "tables.service.title"
                        filter_title        =   "tables.service.filter_title"
                        search_title        =   "tables.service.search_title"
                        [columns]           =   "serviceColumns"
                        [values]            =   "values"
                        [parent]            =   "this"
                        [create]            =   "true"
                        [update]            =   "true"
                        [buttons]           =   "buttons"></custom-table>